/**
 *
 * Plan Selection Modal
 *
 */
import React from 'react';
import {
  ContactLink,
  ContentWrapper,
  Text,
} from './styledComponents';
import Modal from 'components/Modal';
import H1 from 'components/H1';

// This modal used to link to /memento-plan → the self-serve Memento checkout.
// That checkout was removed (its card form could not tokenise a card, and
// nothing had sold through it in eight years), so there is no self-serve path
// to send the user down. The message stays, and the CTA is now "get in touch".
//
// The Intercom messenger is mounted for authenticated users and is the fast
// path, but it is a third-party script: an ad-blocker, an offline moment, or a
// Intercom outage leaves the user reading "contact us" with nothing to click.
// The mailto is the fallback that does not depend on anything loading. It is
// deliberately NOT opened in a new tab (no target="_blank") and shows the
// address as its own visible text — a device with no mail client configured
// would otherwise get an empty blank tab and no other way to see who to
// contact. This is a genuine "talk to sales" prompt (no self-serve checkout
// exists), unlike the plan-gated upgrade CTAs in
// ChannelsPage/Forms/MessagingOptionForm, which route through the shared
// `containers/UpgradeCta` (Stripe's plan-upgrade portal, or a rental
// contact-us mailto) instead.
const PlanSelectionModal = ({ close }) => (
  <Modal shakeOnOpen close={close} title='Plan Selection'>
    <ContentWrapper>
      <H1>
        Subscription required
      </H1>
      <Text>
        Creating a new channel needs an active subscription. Email{' '}
        <ContactLink
          href="mailto:sales@movebooth.com?&subject=Movebooth%20Subscription%20Request&body=I'd like to set up a subscription so I can create a new channel."
        >
          sales@movebooth.com
        </ContactLink>{' '}
        and we'll get you set up on the right plan.
      </Text>
    </ContentWrapper>
  </Modal>
);

export default PlanSelectionModal;
